import './Input.scss'
import React, { PureComponent } from 'react'
import classNames from 'classnames'
import { InputNumber as AntInputNumber } from 'antd'

export default class InputNumber extends PureComponent {
  render() {
    const { className } = this.props
    const inputProps = {
      className: classNames(className, 'pan-input', 'pan-input-number')
    }
    return <AntInputNumber ref={ref => {
      this.inputNumberRef = ref && ref.inputNumberRef
    }} {...this.props} {...inputProps} />
  }

  focus() {
    if (this.inputNumberRef) {
      this.inputNumberRef.focus()
    }
  }

  blur() {
    if (this.inputNumberRef) {
      this.inputNumberRef.blur()
    }
  }
}
InputNumber.AntInputNumber = AntInputNumber
